import Comments from "../../../../src/components/comments";
import * as React from 'react';
export default {
  Comments,
  React
};